  <ng-template #innerContent let-frameRef="frameRef">
    <form [formGroup]="validatingForm">
    <div class="modal-content">

      <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
        <div class="card-header card-header-info">
          <h5 *ngIf="isEdit" style="margin-bottom: 0px !important; font-size: 1.12rem !important;" class="card-title">{{
            'texto_139' | translate }}</h5>
          <h5 *ngIf="!isEdit" style="margin-bottom: 0px !important; font-size: 1.12rem !important;" class="card-title">{{
            'texto_377' | translate }}</h5>
        </div>
        <button type="button" style="z-index:100;float: right;margin-top: -2.8rem;" class="btn btn-dark"
          (click)="onCloseClicked(frameRef)" aria-label="Cerrar modal">X</button>


        <!-- id tp denuncia -->
        <div class="md-form mb-4">
          <input type="text" id="orangeForm-email" class="form-control" [formControl]="complaintTypeId" mdbInput
            mdbValidate [readonly]="isEdit">
          <label for="orangeForm-email">ID. {{ 'texto_71' | translate }}</label>
          <mdb-error *ngIf="complaintTypeId.invalid && (complaintTypeId.dirty || complaintTypeId.touched)">{{
            'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="complaintTypeId.valid && (complaintTypeId.dirty || complaintTypeId.touched)">{{
            'texto_62' | translate }}
          </mdb-success>
        </div>

        <!-- nombre tp denuncia -->
        <div class="md-form mb-3">
          <input type="text" id="orangeForm-name" class="form-control" [formControl]="complaintTypeName" mdbInput
            mdbValidate maxlength="255">
          <label for="orangeForm-name">N. {{ 'texto_71' | translate }}</label>
          <mdb-error *ngIf="complaintTypeName.invalid && (complaintTypeName.dirty || complaintTypeName.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="complaintTypeName.valid && (complaintTypeName.dirty || complaintTypeName.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>

        <!-- orden -->
        <div class="md-form mb-3">
          <input type="number" id="orangeForm-orden" class="form-control" [formControl]="complaintTypeOrder" mdbInput
            mdbValidate maxlength="255">
          <label for="orangeForm-orden">N. {{ 'texto_754' | translate }}</label>
          <mdb-error *ngIf="complaintTypeOrder.invalid && (complaintTypeOrder.dirty || complaintTypeOrder.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="complaintTypeOrder.valid && (complaintTypeOrder.dirty || complaintTypeOrder.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>

        <!-- comentario -->
        <div class="md-form mb-3">
          <label for="form-email">{{ 'texto_46' | translate }}</label>
          <!-- <mdb-icon fas icon="pencil-alt" class="prefix grey-text" style="margin-top: 10%;"></mdb-icon> -->
          <textarea maxlength="4000" type="text" id="form107" class="md-textarea form-control" mdbInput
            [formControl]="complaintTypeDescription"></textarea>
          <mdb-error
            *ngIf="complaintTypeDescription.invalid && (complaintTypeDescription.dirty || complaintTypeDescription.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success
            *ngIf="complaintTypeDescription.valid && (complaintTypeDescription.dirty || complaintTypeDescription.touched)">
            {{ 'texto_62' | translate }} </mdb-success>
        </div>

        <!-- gestor -->
        <div class="md-form mb-3 form-group">
          <label>{{ 'texto_490' | translate }}</label> <br>
          <mat-form-field style="width: 100%;">
            <mat-select [formControl]="gestor">
              <mat-option *ngIf="gestores.length === 0" [value]="null">
                {{ 'texto_909' | translate }}
              </mat-option>

              <mat-option *ngFor="let item of gestores" [value]="item">
                {{item.nombre}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      <!-- gestor conflicto -->
       <!--  -->
        <div class="md-form mb-3 form-group">
          <label>{{ 'texto_690' | translate }}</label> <br>

          <mat-form-field style="width: 100%;">
            <mat-select
              [formControl]="gestorConflicto"
              [attr.disabled]="(!gestor.value || gestor.value?.nombre === ('texto_938' | translate)) ? true : null">

              <mat-option *ngIf="gestores.length === 0" [value]="null">
                {{ 'texto_909' | translate }}
              </mat-option>

              <mat-option *ngFor="let item of gestores" [value]="item">
                {{ item.nombre }}
              </mat-option>

              <!--<mat-option>--</mat-option>-->
              <mat-option *ngIf="gestores.length === 0" [value]="null">
                {{ 'texto_909' | translate }}
              </mat-option>

              <mat-option *ngFor="let item of gestores" [value]="item">
                {{item.nombre}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="text-center mt-3">
        <button *ngIf="!isEdit" (click)="save()" [disabled]="!this.validatingForm.valid" mdbBtn rounded="true"
          class="btn-primary mt-1 waves-light" mdbWavesEffect>{{ 'texto_60' | translate }}</button>
        <button *ngIf="isEdit" (click)="save()" [disabled]="!this.validatingForm.valid" mdbBtn rounded="true"
          class="btn-primary mt-1 waves-light" mdbWavesEffect>{{ 'texto_59' | translate }}</button>
      </div>

    </div>
    </form>
  </ng-template>

  <!-- Non-embedded (original modal usage) -->
  <div *ngIf="!embedded" mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document">
      <ng-container *ngTemplateOutlet="innerContent; context: { frameRef: frame }"></ng-container>
    </div>
  </div>

  <!-- Embedded mode: render only the inner content (no MDB modal wrapper) -->
  <div *ngIf="embedded" class="embedded-add-tipo">
    <ng-container *ngTemplateOutlet="innerContent"></ng-container>
  </div>
